import React, { useState } from "react";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import googleAuthenticationConfig from "../../utils/googleAuthenticationConfig";
import Cookies from "js-cookie";
import { parseAxiosError } from "../../utils/response";
import { STANDARD_ERRORS_WAY, SUPPORTED_LANGUAGES } from "../../utils/consts";
import getLanguageFromUrl from "../../utils/getLanguageFromUrl";

const GoogleButton = ({ authData, setAuthData, notification, setNotification, t }) => {

  const [loading, setLoading] = useState(false);

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      const token = tokenResponse.access_token;

      if (!token) {
        return;
      }

      setLoading(true);

      axios.post("/api", {}, googleAuthenticationConfig(token)).then(response => {
        if (response.status === 200) {
          setAuthData({
            ...authData,
            responseGoogleToken: token,
            authConfig: googleAuthenticationConfig(token)
          });
        }
        if (response.status === 201) {
          Cookies.set("token", response.data.data.attributes.token);
          if (Cookies.get("token")) {
            window.location.href = SUPPORTED_LANGUAGES[getLanguageFromUrl()].url || "/";
          }
        }
      }).catch(error => {
        parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
      }).finally(() => {
        setLoading(false);
      });
    },
    onError: () => {
      setLoading(false);
    }
  });

  return (
    <div className="login-with-google">
      <button
        onClick={() => login()}
        type="button"
        disabled={loading}
        className="login-with-google__button"
      >
        {loading ? <CircularProgress size={18} color="inherit" /> : <span className="icon-social-google" />}
      </button>
      <p className="login-with-google__text">
        {t("useEmailForLogin")}
      </p>
    </div>
  );
};

const GoogleForm = (props) => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <GoogleButton {...props} />
    </GoogleOAuthProvider>
  );
};

export default GoogleForm;
